module.exports = __webpack_public_path__ + "static/media/PremiumIcon.7af6f519.svg";